module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emergency-dashboard"
  }, [_c('div', {
    staticClass: "container main-content"
  }, [_c('div', {
    staticClass: "stat-cards"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-content"
  }, [_c('div', {
    staticClass: "stat-title"
  }, [_vm._v("合格外教")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.totalTeachers))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openSlotDetail('available')
      }
    }
  }, [_c('div', {
    staticClass: "stat-content"
  }, [_c('div', {
    staticClass: "stat-title"
  }, [_vm._v("可用时段")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.totalAvailableSlots))]), _vm._v(" "), _c('div', {
    staticClass: "stat-sub"
  }, [_vm._v("当前总计 · 点击查看明细")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openSlotDetail('used')
      }
    }
  }, [_c('div', {
    staticClass: "stat-content"
  }, [_c('div', {
    staticClass: "stat-title"
  }, [_vm._v("已使用时段")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.usedSlots))]), _vm._v(" "), _c('div', {
    staticClass: "stat-sub"
  }, [_vm._v("当前周 · 点击查看明细")])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('Tabs', {
    key: _vm.isTrialPool ? 'trial' : 'pool',
    staticClass: "main-tabs",
    attrs: {
      "value": "pool"
    },
    on: {
      "on-click": _vm.handleTabChange
    }
  }, [_c('TabPane', {
    attrs: {
      "label": _vm.isTrialPool ? '试听外教池' : '应急外教池',
      "name": "pool"
    }
  }, [(_vm.isTrialPool) ? _c('Alert', {
    staticClass: "trial-rule-alert",
    attrs: {
      "show-icon": ""
    }
  }, [_vm._v("\n          入池规则（三条同时满足）\n          "), _c('div', {
    attrs: {
      "slot": "desc"
    },
    slot: "desc"
  }, [_c('p', [_vm._v("① 所有老师（包括应急外教非应急时间）")]), _vm._v(" "), _c('p', [_vm._v("② 当前外教分数 ≥ 70 分（同本月排行榜总分 / 批量查分接口）")]), _vm._v(" "), _c('p', [_vm._v("③ 单周买断 ≥ 20 节（统计周随搜索日期所在周一至周日）")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-panel"
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 5
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "搜索老师姓名或ID"
    },
    on: {
      "on-enter": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.searchText),
      callback: function($$v) {
        _vm.$set(_vm.filters, "searchText", $$v)
      },
      expression: "filters.searchText"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prefix",
      "type": "ios-search"
    },
    slot: "prefix"
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "tchStudyAdviser",
      "placeholder": "外管",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.tchStudyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tchStudyAdviserId", $$v)
      },
      expression: "filters.tchStudyAdviserId"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "老师来源",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tchChannel", $$v)
      },
      expression: "filters.tchChannel"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("外教")])], 1)], 1), _vm._v(" "), (!_vm.isTrialPool) ? _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "是否应急外教",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.emergency),
      callback: function($$v) {
        _vm.$set(_vm.filters, "emergency", $$v)
      },
      expression: "filters.emergency"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "试听权限",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.isAudition),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isAudition", $$v)
      },
      expression: "filters.isAudition"
    }
  }, [_c('Option', {
    attrs: {
      "value": "y"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "n"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "绑定权限",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.canBound),
      callback: function($$v) {
        _vm.$set(_vm.filters, "canBound", $$v)
      },
      expression: "filters.canBound"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "会中文",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.chinese),
      callback: function($$v) {
        _vm.$set(_vm.filters, "chinese", $$v)
      },
      expression: "filters.chinese"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "gutter": 16
    }
  }, [(!_vm.isTrialPool) ? _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "约课方式"
    },
    on: {
      "on-change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.bookMode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "bookMode", $$v)
      },
      expression: "filters.bookMode"
    }
  }, [_c('Option', {
    attrs: {
      "value": "bind"
    }
  }, [_vm._v("绑定老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "temp"
    }
  }, [_vm._v("临时约课")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "口音",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.accent),
      callback: function($$v) {
        _vm.$set(_vm.filters, "accent", $$v)
      },
      expression: "filters.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "american"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "british"
    }
  }, [_vm._v("英音")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "性别",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters,
      "on-clear": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.gender),
      callback: function($$v) {
        _vm.$set(_vm.filters, "gender", $$v)
      },
      expression: "filters.gender"
    }
  }, [_c('Option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "搜索日期",
      "clearable": false,
      "value": _vm.filters.occupyDate
    },
    on: {
      "on-change": _vm.onOccupyDateChange
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "级别",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.levelGroups),
      callback: function($$v) {
        _vm.$set(_vm.filters, "levelGroups", $$v)
      },
      expression: "filters.levelGroups"
    }
  }, _vm._l((_vm.levelOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "教材",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.materialCodes),
      callback: function($$v) {
        _vm.$set(_vm.filters, "materialCodes", $$v)
      },
      expression: "filters.materialCodes"
    }
  }, _vm._l((_vm.materialOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-actions"
  }, [_c('Button', {
    staticClass: "filter-btn",
    attrs: {
      "type": "primary",
      "size": "large",
      "icon": "ios-search"
    },
    on: {
      "click": _vm.applyFilters
    }
  }, [_vm._v("\n              筛选\n            ")]), _vm._v(" "), _c('Button', {
    staticClass: "reset-btn",
    attrs: {
      "size": "large",
      "icon": "ios-refresh"
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v("\n              重置\n            ")]), _vm._v(" "), (_vm.canRunEmergencyPool && !_vm.isTrialPool) ? _c('Button', {
    staticClass: "run-check-btn",
    attrs: {
      "type": "warning",
      "size": "large",
      "loading": _vm.runCheckLoading
    },
    on: {
      "click": _vm.runEmergencyPoolCheck
    }
  }, [_vm._v("\n              手动执行\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "time-filter-grid"
  }, [_c('div', {
    staticClass: "time-filter-card required"
  }, [_c('div', {
    staticClass: "time-filter-title"
  }, [_vm._v("必选时段（筛选项）")]), _vm._v(" "), _c('div', {
    staticClass: "same-teacher-row"
  }, [_c('span', {
    staticClass: "same-teacher-label"
  }, [_vm._v("是否需要同一个老师")]), _vm._v(" "), _c('Select', {
    staticClass: "same-teacher-select",
    on: {
      "on-change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.sameTeacher),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sameTeacher", $$v)
      },
      expression: "filters.sameTeacher"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "time-row header"
  }, [_c('span', [_vm._v("周几")]), _vm._v(" "), _c('span', [_vm._v("上课时段")]), _vm._v(" "), _c('span', [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.filters.requiredSlots), function(item, index) {
    return _c('div', {
      key: 'required-' + index,
      staticClass: "time-row"
    }, [_c('Select', {
      attrs: {
        "placeholder": "周几",
        "transfer": ""
      },
      model: {
        value: (item.day),
        callback: function($$v) {
          _vm.$set(item, "day", $$v)
        },
        expression: "item.day"
      }
    }, _vm._l((_vm.daysOfWeek), function(day) {
      return _c('Option', {
        key: day.key,
        attrs: {
          "value": day.key
        }
      }, [_vm._v(_vm._s(day.label))])
    }), 1), _vm._v(" "), _c('Select', {
      attrs: {
        "placeholder": "上课时段",
        "transfer": ""
      },
      model: {
        value: (item.slotId),
        callback: function($$v) {
          _vm.$set(item, "slotId", $$v)
        },
        expression: "item.slotId"
      }
    }, _vm._l((_vm.timeSlots), function(slot) {
      return _c('Option', {
        key: slot.id,
        attrs: {
          "value": slot.id
        }
      }, [_vm._v(_vm._s(slot.label))])
    }), 1), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "icon": "trash-a"
      },
      on: {
        "click": function($event) {
          return _vm.removeSlotFilter('required', index)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.addSlotFilter('required')
      }
    }
  }, [_vm._v("+必选时段")])], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "matrix-container"
  }, [_c('div', {
    staticClass: "matrix-header"
  }, [_c('h3', [_vm._v("时段矩阵")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.weekRangeLabel) + "　点击单元格可多选必选时段，再点一次取消")])]), _vm._v(" "), _c('table', {
    staticClass: "matrix-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("时段")]), _vm._v(" "), _vm._l((_vm.daysOfWeek), function(day) {
    return _c('th', {
      key: day.key
    }, [_vm._v(_vm._s(day.label))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.timeSlots), function(slot) {
    return _c('tr', {
      key: slot.id
    }, [_c('td', {
      staticClass: "slot-label"
    }, [_vm._v(_vm._s(slot.label))]), _vm._v(" "), _vm._l((_vm.daysOfWeek), function(day) {
      return _c('td', {
        key: day.key,
        class: _vm.getCellClass(day.key, slot.id),
        on: {
          "click": function($event) {
            return _vm.handleCellClick(day.key, slot.id)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.getCellCount(day.key, slot.id)) + "\n                ")])
    })], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "teacher-list"
  }, [_c('div', {
    staticClass: "teacher-list-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('h3', [_vm._v("外教列表")]), _vm._v(" "), _c('span', [_vm._v("共 " + _vm._s(_vm.filteredTeachers.length) + " 位符合条件的老师")]), _vm._v(" "), _c('span', {
    staticClass: "slot-legend"
  }, [_c('i', {
    staticClass: "slot-tag buyout"
  }), _vm._v("买断\n                "), _c('i', {
    staticClass: "slot-tag shortTerm"
  }), _vm._v("短期固定\n                "), _c('i', {
    staticClass: "slot-tag temp"
  }), _vm._v("临时\n                "), _c('i', {
    staticClass: "slot-tag schedule"
  }), _vm._v("已排课\n                "), _c('i', {
    staticClass: "slot-tag bound"
  }), _vm._v("已绑定\n                "), _c('i', {
    staticClass: "slot-tag leave"
  }), _vm._v("请假\n                "), _c('i', {
    staticClass: "slot-emergency-badge legend"
  }), _vm._v("应急\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "teacher-items"
  }, _vm._l((_vm.filteredTeachers), function(teacher) {
    return _c('div', {
      key: teacher.id,
      staticClass: "teacher-item"
    }, [_c('div', {
      staticClass: "teacher-info"
    }, [_c('div', {
      staticClass: "teacher-main"
    }, [_c('div', {
      staticClass: "teacher-name-row"
    }, [_c('a', {
      staticClass: "teacher-name",
      on: {
        "click": function($event) {
          return _vm.openTchInfoModal(teacher.id)
        }
      }
    }, [_vm._v(_vm._s(teacher.name))]), _vm._v(" "), (_vm.scoreText(teacher)) ? _c('span', {
      staticClass: "tch-score-badge"
    }, [_vm._v(_vm._s(_vm.scoreText(teacher)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "teacher-id"
    }, [_vm._v("#" + _vm._s(teacher.id))])]), _vm._v(" "), _c('div', {
      staticClass: "teacher-meta"
    }, [_c('span', {
      class: ['priority-badge', ("p" + (teacher.priority))]
    }, [_vm._v("\n                      P" + _vm._s(teacher.priority) + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "attr-tag gender"
    }, [(teacher.gender === 'male') ? _c('i', {
      staticClass: "ivu-icon ivu-icon-ios-man"
    }) : _c('i', {
      staticClass: "ivu-icon ivu-icon-ios-woman"
    }), _vm._v("\n                      " + _vm._s(teacher.gender === 'male' ? '男' : '女') + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "attr-tag accent"
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-globe"
    }), _vm._v("\n                      " + _vm._s(teacher.accent === 'american' ? '美音' : '英音') + "\n                    ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-people"
    }), _vm._v("\n                      " + _vm._s(teacher.tchStudyAdviserName || '-') + "\n                    ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-calendar"
    }), _vm._v("\n                      " + _vm._s(teacher.hireDate) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "teacher-qualification"
    }, [_c('span', {
      staticClass: "qual-item pass"
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-checkmark-circle"
    }), _vm._v("\n                      " + _vm._s(teacher.emergency === 1 ? '应急外教' : '非应急外教') + "\n                    ")]), _vm._v(" "), ((teacher.requiredMatchCount || 0) + (teacher.backupMatchCount || 0) > 0) ? _c('span', {
      staticClass: "qual-item match-info"
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-funnel"
    }), _vm._v("\n                      必选 " + _vm._s(teacher.requiredMatchCount || 0) + " / 备选 " + _vm._s(teacher.backupMatchCount || 0) + "\n                    ")]) : _vm._e()])])]), _vm._v(" "), (_vm.getTeacherSlots(teacher.id).length > 0) ? _c('div', {
      staticClass: "teacher-slots"
    }, [_c('div', {
      staticClass: "slots-grid"
    }, _vm._l((_vm.getTeacherSlots(teacher.id)), function(daySlot) {
      return _c('div', {
        key: daySlot.day,
        staticClass: "day-slots"
      }, [_c('span', {
        staticClass: "day-label"
      }, [_vm._v(_vm._s(_vm.getDayLabel(daySlot.day)))]), _vm._v(" "), _c('div', {
        staticClass: "slot-tags"
      }, _vm._l((daySlot.slots), function(slot) {
        return _c('span', {
          key: slot.slotId,
          class: ['slot-tag', _vm.slotDisplayClass(slot)]
        }, [(_vm.isApprovedEmergencySlot(slot)) ? _c('i', {
          staticClass: "slot-emergency-badge",
          attrs: {
            "title": "应急时段"
          }
        }, [_vm._v("应急")]) : _vm._e(), _vm._v("\n                        " + _vm._s(slot.label || _vm.getSlotLabel(slot.slotId) || slot.slotId) + "\n                        "), (slot.status === 'schedule') ? [_vm._v("(已排课)")] : _vm._e(), _vm._v(" "), (slot.status === 'bound') ? [_vm._v("(已绑定)")] : _vm._e(), _vm._v(" "), (slot.status === 'leave') ? [_vm._v("(请假)")] : _vm._e(), _vm._v(" "), (slot.status === 'pending') ? [_vm._v("(待审)")] : _vm._e()], 2)
      }), 0)])
    }), 0)]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.filteredTeachers.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-person"
  }), _vm._v(" "), _c('p', [_vm._v("暂无符合条件的老师")])]) : _vm._e()])], 1), _vm._v(" "), (!_vm.isTrialPool) ? _c('TabPane', {
    attrs: {
      "label": "待审核时段",
      "name": "pending"
    }
  }, [_c('div', {
    staticClass: "pending-review"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pending-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('h3', [_vm._v("待审核时段")]), _vm._v(" "), _c('Tag', {
    attrs: {
      "size": "small",
      "color": "#E6A23C"
    }
  }, [_vm._v(_vm._s(_vm.pendingList.length) + " 个待审核")])], 1), _vm._v(" "), (_vm.selectedIds.length > 0) ? _c('div', {
    staticClass: "header-right"
  }, [_c('span', {
    staticClass: "selected-count"
  }, [_vm._v("已选 " + _vm._s(_vm.selectedIds.length) + " 项")]), _vm._v(" "), _c('Button', {
    staticClass: "btn-success",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.batchApprove
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-checkmark"
  }), _vm._v(" 批量通过\n                ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn-danger",
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.batchReject
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-close"
  }), _vm._v(" 批量拒绝\n                ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pending-info-bar"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-information-circle"
  }), _vm._v(" "), _c('span', [_vm._v("\n                当学生结课或停课后，空出的外教时段如符合应急时段条件，将自动锁定为\"待审核\"状态。\n                请审核后决定是否加入应急池。\n              ")])]), _vm._v(" "), (_vm.pendingList.length > 0) ? _c('div', {
    staticClass: "pending-list"
  }, [_c('Checkbox', {
    staticClass: "select-all-checkbox",
    on: {
      "on-change": _vm.handleSelectAll
    },
    model: {
      value: (_vm.selectAll),
      callback: function($$v) {
        _vm.selectAll = $$v
      },
      expression: "selectAll"
    }
  }, [_vm._v("\n                全选\n              ")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.selectedIds),
      callback: function($$v) {
        _vm.selectedIds = $$v
      },
      expression: "selectedIds"
    }
  }, _vm._l((_vm.pendingList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "pending-item"
    }, [_c('Checkbox', {
      staticClass: "item-checkbox",
      attrs: {
        "label": item.id
      }
    }, [_c('span')]), _vm._v(" "), _c('div', {
      staticClass: "pending-info"
    }, [_c('div', {
      staticClass: "pending-teacher"
    }, [_c('span', {
      staticClass: "teacher-name"
    }, [_vm._v(_vm._s(item.teacher && item.teacher.name || '未知老师'))]), _vm._v(" "), _c('span', {
      staticClass: "teacher-id"
    }, [_vm._v("#" + _vm._s(item.teacherId))]), _vm._v(" "), (item.teacher) ? _c('span', {
      class: ['qualification-badge', _vm.isQualified(item.teacher) ? 'qualified' : 'unqualified']
    }, [_vm._v("\n                      " + _vm._s(_vm.isQualified(item.teacher) ? '符合资格' : '不符合资格') + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "pending-slot"
    }, [_c('Tag', {
      attrs: {
        "size": "small",
        "color": "#E6A23C"
      }
    }, [_vm._v(_vm._s(_vm.getDayLabel(item.day)))]), _vm._v(" "), _c('Tag', {
      attrs: {
        "size": "small",
        "color": "#909399"
      }
    }, [_vm._v(_vm._s(_vm.getSlotLabel(item.slotId)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "pending-reason"
    }, [_c('Tag', {
      attrs: {
        "size": "small",
        "color": item.reason === 'student_completed' ? '#67C23A' : '#409EFF'
      }
    }, [_vm._v("\n                      " + _vm._s(item.reason === 'student_completed' ? '学生结课' : '学生停课') + "\n                    ")]), _vm._v(" "), (item.studentInfo) ? _c('span', [_vm._v(_vm._s(item.studentInfo))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "pending-time"
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-time"
    }), _vm._v(" " + _vm._s(item.createdAt) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "pending-actions"
    }, [_c('Button', {
      staticClass: "btn-success",
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.handleApprove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-checkmark"
    }), _vm._v(" 通过\n                  ")]), _vm._v(" "), _c('Button', {
      staticClass: "btn-danger",
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.handleReject(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "ivu-icon ivu-icon-ios-close"
    }), _vm._v(" 拒绝\n                  ")])], 1)], 1)
  }), 0)], 1) : _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-document"
  }), _vm._v(" "), _c('p', [_vm._v("暂无待审核时段")])])])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), (!_vm.isTrialPool) ? _c('Modal', {
    attrs: {
      "title": "手动执行",
      "mask-closable": false,
      "width": "420"
    },
    model: {
      value: (_vm.runRangeVisible),
      callback: function($$v) {
        _vm.runRangeVisible = $$v
      },
      expression: "runRangeVisible"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择时间范围",
      "transfer": ""
    },
    model: {
      value: (_vm.runDateRange),
      callback: function($$v) {
        _vm.runDateRange = $$v
      },
      expression: "runDateRange"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.closeRunRange
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.runCheckLoading
    },
    on: {
      "click": _vm.submitRunCheck
    }
  }, [_vm._v("确定")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.slotDetailTitle,
      "mask-closable": false,
      "width": "1200"
    },
    model: {
      value: (_vm.slotDetailVisible),
      callback: function($$v) {
        _vm.slotDetailVisible = $$v
      },
      expression: "slotDetailVisible"
    }
  }, [(_vm.slotDetailKind === 'used') ? _c('Date-picker', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择时间范围",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onSlotDetailRangeChange
    },
    model: {
      value: (_vm.slotDetailDateRange),
      callback: function($$v) {
        _vm.slotDetailDateRange = $$v
      },
      expression: "slotDetailDateRange"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.slotDetailKind === 'used') ? _c('div', {
    staticClass: "slot-detail-week"
  }, [_vm._v("统计范围 " + _vm._s(_vm.slotDetail.weekStart) + " ~ " + _vm._s(_vm.slotDetail.weekEnd) + "，共 " + _vm._s(_vm.slotDetail.total) + " 条")]) : _c('div', {
    staticClass: "slot-detail-week"
  }, [_vm._v("统计周 " + _vm._s(_vm.slotDetail.weekStart) + " ~ " + _vm._s(_vm.slotDetail.weekEnd) + "，共 " + _vm._s(_vm.slotDetail.total) + " 条")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.slotDetailColumns,
      "data": _vm.slotDetail.list,
      "loading": _vm.slotDetailLoading,
      "height": "480"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.slotDetailVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-icon blue"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-person"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-icon green"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-time"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-icon purple"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-checkmark-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-568b3b1e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emergency/TeacherPoolOriginal.vue
// module id = 1805
// module chunks = 8